








import { Component, Vue, Prop } from 'vue-property-decorator'
import { TabRoute } from '@/types/frontend'

@Component({
  components: {}
})
export default class TabPanel extends Vue {
  @Prop(Array) readonly routes!: TabRoute<any>[]
  @Prop({ default: false }) readonly loading!: boolean
}

